import _property from 'lodash/property';

var beanType = _property('beantype');

var createdTime = _property('createdTime');

var description = _property('description');

var id = _property('id');

var modifiedTime = _property('modifiedTime');

var partKitNumber = _property('partNumber');

var fixedPriceApplied = _property('fixedPriceApplied');

var partKitMappings = _property('partKitMappings');

var lastModifiedByUserId = _property('lastModifiedByUserId');

var totalSellingPrice = _property('totalSellingPrice');

var READER = {
  beanType: beanType,
  createdTime: createdTime,
  description: description,
  id: id,
  modifiedTime: modifiedTime,
  partKitNumber: partKitNumber,
  partKitMappings: partKitMappings,
  fixedPriceApplied: fixedPriceApplied,
  lastModifiedByUserId: lastModifiedByUserId,
  totalSellingPrice: totalSellingPrice
};
export default READER;